import { makeStyles } from "@material-ui/core";

interface ScoreProps {
  isEmptyScore?: boolean;
  isFullScreen?: boolean;
}

export const useStyles = makeStyles((theme) => ({
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  score: {
    "& .MuiBox-root ": {
      marginInlineStart: "0px!important",
      "& .circle": {
        width: "81px!important",
        height: "81px!important",
      },
      "& div:nth-child(1)": {
        fontFamily: "Lato",
        fontWeight: 700,
        fontSize: theme.typography.pxToRem(28),
        color: theme.palette.common.black,
      },
    },
  },
  topScrollPaper: {
    justifyContent: "end",
    alignItems: "start",
    "& > div": {
      containerName: "dialog",
      containerType: "size",
    },
  },
  dialogContent: {
    height: "600px",
  },
  dialog: {
    top: "35px",
    right: "-29px",
    minHeight: "600px",
    [theme.breakpoints.up("sm")]: {
      width: "486px",
      maxWidth: "600px",
    },
    [theme.breakpoints.only("xs")]: {
      maxWidth: "100%",
      width: "100%",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.common.black,
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.common.black,
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(22),
      marginBottom: "15px",
    },
  },
  financialSection: (props: ScoreProps) => ({
    margin: "26px 0px 26px 0px",
    // backgroundColor: isEmtyScore"#FEEFEA",
    backgroundColor: `${props?.isEmptyScore ? "#F1F5F9" : "#FEEFEA"}`,
    borderRadius: "10px",
    padding: "32px 24px",
    height: "84%",
    display: "flex",
    alignItems: "center",
  }),
  menuActions: {
    marginTop: "15px",
    marginBottom: "15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  resourcesButton: {
    width: "170px",
  },
  footerActions: {
    padding: "8px 24px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& svg": {
      width: 24,
      height: 32,
      "&:hover": {
        cursor: "pointer",
      },
    },
    "& .MuiTypography-body2": {
      fontFamily: "Lato",
      fontWeight: "400",
      fontSize: theme.typography.pxToRem(14),
      color: "#747F9D",
      marginRight: "15px",
      [theme.breakpoints.down("xs")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      borderTop: "1px solid #E6E6E6",
    },
  },
  scheduleMeeting: {
    marginTop: "15px",
  },
  avatar: {
    width: "91px",
    height: "91px",
  },
  oneAndOne: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
    "& button[disabled]": {
      color: "#D1D8DF",
      background: "#F1F5F9",
    },
  },
  myProfile: {
    width: "140px",
  },
  flexCenter: {
    padding: "20px 0px 15px 0px",
    display: "flex",
    alignItems: "center",
    "& .MuiAvatar-circular": {
      width: "75px",
      height: "75px",
      marginRight: "20px",
    },
    "& .MuiTypography-h6": {
      fontFamily: "Inter",
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(22),
    },
  },
  logoutButton: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    color: "black",
    background: "#fafbfc",
    padding: "8px 24px",
    gap: "8px",
    borderRadius: "100px",
    width: "100%",
    "&:hover": {
      background: "#E6F1FF",
      color: "black",
    },
  },
  logOutIcon: {
    color: "black",
  },
}));
